import { GridColDef } from '@mui/x-data-grid-premium';
import { EnhancedDataGrid } from 'components/enhanced/data-grid/index';
import AddEnhancedButton from 'components/ui/buttons/AddEnhancedButton';
import { TenantPage } from 'layouts';
import { useTranslation } from 'react-i18next';
import { accessorService } from '../api/accessor.service.ts';
import { AccessoryColumns } from '../accessories';

export const AccessoryListView = () => {
  const translationPrefix = 'pages.accessories';
  const { t } = useTranslation();

  const columns: GridColDef[] = AccessoryColumns();

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}
      pageType="accessories"
      menuRight={<AddEnhancedButton prefix={translationPrefix} to="new" requireTenantAdmin />}>
      <EnhancedDataGrid columns={columns} service={accessorService} />
    </TenantPage>
  );
};

export default AccessoryListView;
